import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M1807.12429,0.0564689274 L1807.12429,1920 L1694.18644,1920 L1694.18644,0.0564689274 L1807.12429,0.0564689274 Z M1468.25426,1.13686838e-13 L1468.25426,1919.94353 L282.406782,1919.94353 C189.007176,1919.94353 113,1844.04929 113,1750.53675 L113,1750.53675 L113,169.406782 C113,76.0071763 189.007176,1.13686838e-13 282.406782,1.13686838e-13 L282.406782,1.13686838e-13 L1468.25426,1.13686838e-13 Z M830.607129,661.138202 L588.242493,903.502838 L1242.37855,903.502838 L1242.37855,1016.44069 L588.242493,1016.44069 L830.607129,1258.91827 L750.760066,1338.76533 L371.966501,959.971766 L750.760066,581.291138 L830.607129,661.138202 Z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconExpandLeftSolid = /*#__PURE__*/function (_Component) {
  _inherits(IconExpandLeftSolid, _Component);

  var _super = _createSuper(IconExpandLeftSolid);

  function IconExpandLeftSolid() {
    _classCallCheck(this, IconExpandLeftSolid);

    return _super.apply(this, arguments);
  }

  _createClass(IconExpandLeftSolid, [{
    key: "render",
    value: function render() {
      if (process.env.NODE_ENV !== 'production') {}

      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconExpandLeft",
        viewBox: "0 0 1920 1920",
        bidirectional: true
      }), _ref);
    }
  }]);

  IconExpandLeftSolid.displayName = "IconExpandLeftSolid";
  return IconExpandLeftSolid;
}(Component);

IconExpandLeftSolid.glyphName = 'expand-left';
IconExpandLeftSolid.variant = 'Solid';
IconExpandLeftSolid.deprecated = true;
IconExpandLeftSolid.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconExpandLeftSolid;
export { IconExpandLeftSolid };